
 enum StatusWindow {
    Text = 1,
    Error,
    Warning,
    Info
}
export default StatusWindow;
